import {
  Config,
  InitApiType,
  EndPointsNames,
  ApiCredentialsType,
  ErrorResponseCodeType,
} from '../Core';
import { CmsContentTypes } from '../Types';

export const API_DOMAIN: EndPointsNames = 'ApiGwBr';
export const ENDPOINT_API_PATH = '/cms/content/v1/get-content';

export const API_CREDENTIALS_TYPE: ApiCredentialsType = 'NOT_CREDENTIALS';
export const URL_POSTMAN = ``;

export const CODE_ERRORS: ErrorResponseCodeType<null>[] = [
  {
    code: '1',
    bussinessErrorVariant: 'errorService',
    message:
      'Ocorreu um erro técnico (Erro inesperado, favor contactar a Smiles)',
  },
];

const definitions = {
  API_DOMAIN,
  ENDPOINT_API_PATH,
  API_CREDENTIALS_TYPE,
  URL_POSTMAN,
  CODE_ERRORS,
};

const callGet = async (
  params: CmsContentTypes.CmsContentRequestType,
): Promise<CmsContentTypes.ICmsContentServiceResponse> => {
  const init: InitApiType = {
    params,
  };

  delete init.params.type;

  return Config.API.get(
    definitions.API_DOMAIN,
    definitions.ENDPOINT_API_PATH,
    definitions.API_CREDENTIALS_TYPE,
    init,
  );
};
const call = { get: callGet };
export default { call, definitions };
